module.exports = __webpack_public_path__ + "cabc589b7d7d2b097f719ccf1285af4e.png";